/*
 # Modal Close Others

 This co-controller is applied to an accordion and has the effect
 of closing other accordions when opened.

 The other accordions that will be closed are specified with a data
 attribute of:

 data-accordion-close-group="accordion-a accordion-b"

 the value of this attribute is consumed in relationship to
 other accordion instances which have the same attribute,
 on a space-delimited basis.

*/

import {
  assignController, getControllers, controllersAvailable,
  selectAll,
} from '../api/element-manipulation'

assignController('accordionCloseOthers', (element) => {

  const handleOpened = () => {
    const closeGroups = (element.dataset.accordionCloseGroup || '').split(' ')
    const others = closeGroups.reduce((matches, closeGroup) => {
      const newMatches = selectAll(document, `[data-hook~="accordion"][data-accordion-close-group~="${closeGroup}"]`)
      newMatches.forEach(newMatch => {
        if ( (newMatch !== element) && (!matches.includes(newMatch))) {
          matches = [...matches, newMatch]
        }
      })
      return matches
    }, [])
    others.forEach(otherElement => {
      const accordion = getControllers(otherElement).accordion
      accordion.close()
    })
  }

  controllersAvailable( () => {
    const accordion = getControllers(element).accordion
    if ( !accordion ) {
      return
    }
    accordion.opened.push(handleOpened)
  } )

  return {
    element,
  }
})
